<template>
  <div>
    <div class="flex mb-6 border-b border-solid border-light-grey-900 overflow-x-auto" v-if="numberOfTabs > 0">
      <div class="py-3 mr-4 sm:mr-8 last:mr-0" v-for="number in numberOfTabs" :key="number">
        <skeleton-loader class="mb-0" width="80px" />
      </div>
    </div>

    <skeleton-loader class="mb-4" height="1.5rem" width="220px" />

    <div class="grid grid-cols-12 mb-8">
      <div class="col-span-12 md:col-span-8 lg:col-span-7">
        <skeleton-list :rows="8" />
      </div>
    </div>

    <div class="flex items-center justify-between mb-4">
      <skeleton-loader height="1.5rem" width="120px" />
      <skeleton-loader height="2rem" width="100px" />
    </div>

    <skeleton-table :number-of-rows="3" :number-of-columns="5" />
  </div>
</template>

<script>
import { SkeletonList, SkeletonLoader, SkeletonTable } from '@/components/ContentLoader/components'

export default {
  name: 'DetailPageLayout',

  components: { SkeletonList, SkeletonLoader, SkeletonTable },

  props: {
    numberOfTabs: {
      type: Number,
      default: 0
    }
  }
}
</script>
